module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/archive/archive/archive-details/archive-details.component.css
// module id = ./src/app/views/archive/archive/archive-details/archive-details.component.css
// module chunks = main